<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ title }}</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="freezing"
          method="post"
          :action="url"
          @submitted="$emit('edited', $event)"
        >
          <custom-textarea name="reason" label="Freezing Reason" />
          <custom-button block color="primary">
            <v-icon>mdi-account-edit</v-icon>Edit
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    isUndo: { type: Boolean, default: false },
    criminalCase: {
      required: true,
      type: Object,
    },
    user: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      freezing: {
        reason: "",
      },
    };
  },
  computed: {
    url() {
      return this.isUndo
        ? `/api/v1/users/${this.criminalCase.pivot.client_id}/undo/${this.criminalCase.id}`
        : `/api/v1/users/freeze/${this.criminalCase.id}`;
    },
    title() {
      return this.isUndo ? "Reflag User: " + this.user.first_name : "Freeze User";
    },
  },
  created() {},
};
</script>
